import React from 'react';
import { useAppDispatch } from '../../hooks/useAppDispatcher.hook';
import { getEmployeeListThunk } from '../../redux/Employee/Employee.thunk';
import { Employee } from '../../redux/Employee/Employee.type';
import { filterByRegionIntersection } from '../../services/employee.service';
import UserBadgeComponent from '../UserBadge.component';
import SelectComponent, {
  SelectOptionProps,
} from './Select.component';
import { StyledSelectOption } from '../Modal/Candidate/Record/styledComponents';
import useAuthHook from '../../hooks/useAuth.hook';
import { SpecificEmployeeGroupFilter } from './types';
import { NOT_ASSIGN_ITEM } from '../../constants/filters.constant';

const EmployeeSelect = ({
  label,
  placeholder,
  value,
  onChangeOption,
  blink,
  disabled,
  tooltip,
  isFilteredByRegionIntersection = false,
  specificGroupFilter,
  isMulti = false,
  menuPlacement = 'auto',
  useMenuPortalTarget = false,
  validationFailureMessage,
  notAssignItem = false,
}: {
  label: string;
  placeholder: string;
  value?: SelectOptionProps;
  initOptions?: SelectOptionProps[];
  onChangeOption: (value: any) => void;
  blink?: boolean;
  disabled?: boolean;
  tooltip?: string;
  /**
   * Filter by region intercection authUser.regions x select option employee.regions
   */
  isFilteredByRegionIntersection?: boolean;
  isMulti?: boolean;
  menuPlacement?: 'auto' | 'top' | 'bottom';
  useMenuPortalTarget?: boolean;
  specificGroupFilter?: SpecificEmployeeGroupFilter;
  validationFailureMessage?: string;
  notAssignItem?: boolean
}) => {
  const dispatch = useAppDispatch();
  const { user } = useAuthHook();

  const employeeListLoadOptions = async (
    search: string,
    loadedOptions: string | any[],
    { group, page }: any,
  ) => {
    const {
      payload: { data: allEmployees, pagination },
    } = await dispatch(getEmployeeListThunk({ group, search, page }));

    let employees = allEmployees;

    if (isFilteredByRegionIntersection) {
      const regionIdsUserHasAccessTo = user.regions.map((region: { id: any; }) => region.id);
      employees = filterByRegionIntersection(allEmployees, regionIdsUserHasAccessTo);
    }

    return {
      options: employees.map((item: Employee) => ({
        value: item.id,
        label: (
          <StyledSelectOption>
            <UserBadgeComponent info={item} />
          </StyledSelectOption>
        ),
        available: item.available,
      })),
      hasMore: pagination.current_page < pagination.last_page,
      additional: {
        group,
        page: pagination.current_page + 1,
      },
    };
  };

  const additionalFilterOptions =
    specificGroupFilter === 'hr' || specificGroupFilter === 'recruiter'
    ? { group: { hr: true } }
    : undefined;

  return (
    <SelectComponent
      label={label}
      placeholder={placeholder}
      tooltip={tooltip}
      value={value}
      initOptions={notAssignItem ? [NOT_ASSIGN_ITEM] : undefined}
      loadOptions={employeeListLoadOptions}
      additional={additionalFilterOptions}
      onChangeOption={onChangeOption}
      blink={blink}
      isMulti={isMulti}
      menuPlacement={menuPlacement}
      useMenuPortalTarget={useMenuPortalTarget}
      disabled={disabled}
      validationFailureMessage={validationFailureMessage}
    />
  );
};

export default EmployeeSelect;
